import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "128",
  height: "128",
  fill: "none",
  viewBox: "0 0 128 128"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_11_311)\"><path fill=\"#006345\" fill-rule=\"evenodd\" d=\"M128 117.3c0 5.909-4.757 10.7-10.625 10.7H43V21h85z\" clip-rule=\"evenodd\"></path><path fill=\"#00B064\" fill-rule=\"evenodd\" d=\"M106.944 102.304c-.682 8.23-7.532 14.696-15.882 14.696H22V10h85v92.287z\" clip-rule=\"evenodd\"></path><path fill=\"#00E281\" fill-rule=\"evenodd\" d=\"M84.944 92.304C84.262 100.534 77.412 107 69.062 107H0V0h85v92.288z\" clip-rule=\"evenodd\"></path><path fill=\"#00B064\" d=\"M64 58H21v11h43zM64 80H21v11h43z\"></path><path fill=\"#006345\" d=\"M43 48c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16\"></path></g>", 1)
  ]))]))
}
export default { render: render }